module.exports = __webpack_public_path__ + "static/media/shriram-logo.3bbb6423.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/clients/shriram-logo.jpg
 ** module id = 775
 ** module chunks = 0
 **/